module.exports = __webpack_public_path__ + "static/media/SourceSansPro-RegularItalic.1fd341b5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-RegularItalic.woff2
// module id = 3755
// module chunks = 68